import _extends from "@babel/runtime/helpers/esm/extends";
import { ExtendableEventCalendarStore } from '@mui/x-scheduler-internals/use-event-calendar';
import { EventCalendarPremiumLazyLoadingPlugin } from "./plugins/EventCalendarPremiumLazyLoadingPlugin.mjs";
import { schedulerRecurringEventsPlugin } from "../internals/plugins/schedulerRecurringEventsPlugin.mjs";
/**
 * Premium version of EventCalendarStore with premium plugins.
 */
export class EventCalendarPremiumStore extends ExtendableEventCalendarStore {
  constructor(parameters, adapter) {
    super(parameters, adapter, 'EventCalendarPremiumStore', schedulerRecurringEventsPlugin);
    this.lazyLoading = new EventCalendarPremiumLazyLoadingPlugin(this);
  }
  buildPublicAPI() {
    return _extends({}, super.buildPublicAPI());
  }
}